import React from "react";
import styled from "styled-components";
import Header from "./Header";
import Methods from "./Methods";
import Table from "./Table";

interface Props {}

const Shorokov: React.FC<Props> = () => {
  return (
    <Background>
      <Header />
      <Body>
        <Methods />
        <Table />
      </Body>
    </Background>
  );
};

const Background = styled.div`
  background-color: black;
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Body = styled.div`
  padding: 30px;
  gap: 30px;
  display: flex;
  flex-direction: column;
`;

export default Shorokov;
